import { jsx as _jsx } from "react/jsx-runtime";
import { SPA_ROUTES } from '#pplx/frontend/apps/ask/routing/spaRoutes.js';
import { DocumentTitle } from '#pplx/frontend/apps/ask/spa/metadata/DocumentTitle.js';
import { useRouteDocumentMetadata } from '#pplx/frontend/apps/ask/spa/metadata/routeDocumentMetadata.js';
import { useMetadata } from '#pplx/frontend/apps/ask/spa/metadata/useMetadata.js';
import { usePathname } from '#pplx/frontend/router/usePathname.js';
import React from 'react';
export const Title = React.memo(function Title() {
    const metadata = useMetadata(SPA_ROUTES);
    const pathname = usePathname() ?? '';
    const override = useRouteDocumentMetadata(pathname);
    return _jsx(DocumentTitle, { metadata: override ?? metadata });
});
//# sourceMappingURL=title.js.map